// AGC: Complete icon catalog for machinery icon picker
// AGC: Maps category → subcategory → available color variants

const B = '/Machinery_icons/machinery_transparent'

export interface IconSubtype {
  key: string
  label: string
  colors: { color: string; path: string }[]
}

export interface IconCategory {
  id: string
  label: string
  subtypes: IconSubtype[]
}

export const ICON_CATALOG: IconCategory[] = [
  {
    id: 'trator',
    label: 'Tratores',
    subtypes: [
      {
        key: 'trator_pequeno', label: 'Trator Pequeno — sem cabine (até 75cv)',
        colors: [
          { color: 'amarelo', path: `${B}/trator_pequeno_amarelo2126.png` },
          { color: 'azul', path: `${B}/trator_pequeno_azul2128.png` },
          { color: 'laranja', path: `${B}/trator_pequeno_laranja2130.png` },
          { color: 'verde', path: `${B}/trator_pequeno_verde2132.png` },
          { color: 'vermelho', path: `${B}/trator_pequeno_vermelho2134.png` },
        ],
      },
      {
        key: 'trator_medio', label: 'Trator Médio — com cabine (75-180cv)',
        colors: [
          { color: 'amarelo', path: `${B}/trator_pequeno_amarelo125.png` },
          { color: 'azul', path: `${B}/trator_pequeno_azul127.png` },
          { color: 'laranja', path: `${B}/trator_pequeno_laranja129.png` },
          { color: 'verde', path: `${B}/trator_pequeno_verde131.png` },
          { color: 'vermelho', path: `${B}/trator_pequeno_vermelho133.png` },
        ],
      },
      {
        key: 'trator_grande', label: 'Trator Grande (180-350cv)',
        colors: [
          { color: 'amarelo', path: `${B}/trator_medio_amarelo120.png` },
          { color: 'azul', path: `${B}/trator_medio_azul121.png` },
          { color: 'laranja', path: `${B}/trator_medio_laranja122.png` },
          { color: 'verde', path: `${B}/trator_medio_verde123.png` },
          { color: 'vermelho', path: `${B}/trator_medio_vermelho124.png` },
        ],
      },
      {
        key: 'trator_articulado', label: 'Trator Articulado (350cv+)',
        colors: [
          { color: 'amarelo', path: `${B}/trator_articulado_amarelo110.png` },
          { color: 'azul', path: `${B}/trator_articulado_azul111.png` },
          { color: 'laranja', path: `${B}/trator_articulado_laranja112.png` },
          { color: 'verde', path: `${B}/trator_articulado_verde113.png` },
          { color: 'vermelho', path: `${B}/trator_articulado_vermelho114.png` },
        ],
      },
      {
        key: 'trator_esteira', label: 'Trator de Esteira',
        colors: [
          { color: 'amarelo', path: `${B}/trator_esteira_amarelo115.png` },
          { color: 'azul', path: `${B}/trator_esteira_azul116.png` },
          { color: 'laranja', path: `${B}/trator_esteira_laranja117.png` },
          { color: 'verde', path: `${B}/trator_esteira_verde118.png` },
          { color: 'vermelho', path: `${B}/trator_esteira_vermelho119.png` },
        ],
      },
    ],
  },
  {
    id: 'colheitadeira',
    label: 'Colheitadeiras',
    subtypes: [
      {
        key: 'colheitadeira_graos', label: 'Colheitadeira de Grãos',
        colors: [
          { color: 'amarelo', path: `${B}/colheitadeira_graos_amarelo31.png` },
          { color: 'azul', path: `${B}/colheitadeira_graos_azul32.png` },
          { color: 'laranja', path: `${B}/colheitadeira_graos_laranja33.png` },
          { color: 'verde', path: `${B}/colheitadeira_graos_verde34.png` },
          { color: 'vermelho', path: `${B}/colheitadeira_graos_vermelho35.png` },
        ],
      },
      {
        key: 'colheitadeira_cana', label: 'Colheitadeira de Cana',
        colors: [
          { color: 'amarelo', path: `${B}/colheitadeira_cana_amarelo20.png` },
          { color: 'azul', path: `${B}/colheitadeira_cana_azul21.png` },
          { color: 'laranja', path: `${B}/colheitadeira_cana_laranja23.png` },
          { color: 'verde', path: `${B}/colheitadeira_cana_verde24.png` },
          { color: 'vermelho', path: `${B}/colheitadeira_cana_vermelho25.png` },
        ],
      },
      {
        key: 'colheitadeira_algodao', label: 'Colheitadeira de Algodão',
        colors: [
          { color: 'amarelo', path: `${B}/colheitadeira_algodao_amarelo10.png` },
          { color: 'azul', path: `${B}/colheitadeira_algodao_azul12.png` },
          { color: 'laranja', path: `${B}/colheitadeira_algodao_laranja14.png` },
          { color: 'verde', path: `${B}/colheitadeira_algodao_verde16.png` },
          { color: 'vermelho', path: `${B}/colheitadeira_algodao_vermelho18.png` },
        ],
      },
      {
        key: 'colheitadeira_forragem', label: 'Colheitadeira de Forragem',
        colors: [
          { color: 'amarelo', path: `${B}/colheitadeira_forragem_amarelo26.png` },
          { color: 'azul', path: `${B}/colheitadeira_forragem_azul27.png` },
          { color: 'laranja', path: `${B}/colheitadeira_forragem_laranja28.png` },
          { color: 'verde', path: `${B}/colheitadeira_forragem_verde29.png` },
          { color: 'vermelho', path: `${B}/colheitadeira_forragem_vermelho30.png` },
        ],
      },
    ],
  },
  {
    id: 'plantadeira',
    label: 'Plantadeiras',
    subtypes: [
      {
        key: 'plantadeira_4_linhas', label: 'Plantadeira 4-8 Linhas',
        colors: [
          { color: 'amarelo', path: `${B}/plantadeira_4_linhas_amarelo67.png` },
          { color: 'azul', path: `${B}/plantadeira_4_linhas_azul68.png` },
          { color: 'laranja', path: `${B}/plantadeira_4_linhas_laranja69.png` },
          { color: 'verde', path: `${B}/plantadeira_4_linhas_verde271.png` },
          { color: 'vermelho', path: `${B}/plantadeira_4_linhas_vermelho72.png` },
        ],
      },
      {
        key: 'plantadeira_12_linhas', label: 'Plantadeira 12-16 Linhas',
        colors: [
          { color: 'amarelo', path: `${B}/plantadeira_12_linhas_amarelo57.png` },
          { color: 'azul', path: `${B}/plantadeira_12_linhas_azul58.png` },
          { color: 'laranja', path: `${B}/plantadeira_12_linhas_laranja59.png` },
          { color: 'verde', path: `${B}/plantadeira_12_linhas_verde60.png` },
          { color: 'vermelho', path: `${B}/plantadeira_12_linhas_vermelho61.png` },
        ],
      },
      {
        key: 'plantadeira_24_linhas', label: 'Plantadeira 24+ Linhas',
        colors: [
          { color: 'amarelo', path: `${B}/plantadeira_24_linhas_amarelo62.png` },
          { color: 'azul', path: `${B}/plantadeira_24_linhas_azul63.png` },
          { color: 'laranja', path: `${B}/plantadeira_24_linhas_laranja64.png` },
          { color: 'verde', path: `${B}/plantadeira_24_linhas_verde65.png` },
          { color: 'vermelho', path: `${B}/plantadeira_24_linhas_vermelho66.png` },
        ],
      },
      {
        key: 'plantadeira_pneumatica', label: 'Plantadeira Pneumática',
        colors: [
          { color: 'amarelo', path: `${B}/plantadeira_pneumatica_amarelo73.png` },
          { color: 'azul', path: `${B}/plantadeira_pneumatica_azul74.png` },
          { color: 'laranja', path: `${B}/plantadeira_pneumatica_laranja75.png` },
          { color: 'verde', path: `${B}/plantadeira_pneumatica_verde76.png` },
          { color: 'vermelho', path: `${B}/plantadeira_pneumatica_vermelho77.png` },
        ],
      },
      {
        key: 'semeadora_lanco', label: 'Semeadora a Lanço',
        colors: [
          { color: 'amarelo', path: `${B}/semeadora_lanco_amarelo97.png` },
          { color: 'azul', path: `${B}/semeadora_lanco_azul98.png` },
          { color: 'laranja', path: `${B}/semeadora_lanco_laranja99.png` },
          { color: 'verde', path: `${B}/semeadora_lanco_verde100.png` },
          { color: 'vermelho', path: `${B}/semeadora_lanco_vermelho101.png` },
        ],
      },
    ],
  },
  {
    id: 'pulverizador',
    label: 'Pulverizadores',
    subtypes: [
      {
        key: 'pulverizador_barras', label: 'Pulverizador Arrasto',
        colors: [
          { color: 'amarelo', path: `${B}/pulverizador_barras_amarelo84.png` },
          { color: 'azul', path: `${B}/pulverizador_barras_azul85.png` },
          { color: 'laranja', path: `${B}/pulverizador_barras_laranja86.png` },
          { color: 'verde', path: `${B}/pulverizador_barras_verde288.png` },
          { color: 'vermelho', path: `${B}/pulverizador_barras_vermelho89.png` },
        ],
      },
      {
        key: 'pulverizador_autopropelido', label: 'Pulverizador Autopropelido',
        colors: [
          { color: 'amarelo', path: `${B}/pulverizador_autopropelido_amarelo79.png` },
          { color: 'azul', path: `${B}/pulverizador_autopropelido_azul80.png` },
          { color: 'laranja', path: `${B}/pulverizador_autopropelido_laranja81.png` },
          { color: 'verde', path: `${B}/pulverizador_autopropelido_verde82.png` },
          { color: 'vermelho', path: `${B}/pulverizador_autopropelido_vermelho83.png` },
        ],
      },
      {
        key: 'pulverizador_costal', label: 'Pulverizador Costal',
        colors: [
          { color: 'amarelo', path: `${B}/pulverizador_costal_amarelo90.png` },
          { color: 'azul', path: `${B}/pulverizador_costal_azul91.png` },
          { color: 'laranja', path: `${B}/pulverizador_costal_laranja92.png` },
          { color: 'verde', path: `${B}/pulverizador_costal_verde93.png` },
          { color: 'vermelho', path: `${B}/pulverizador_costal_vermelho94.png` },
        ],
      },
      {
        key: 'atomizador', label: 'Atomizador / Turbopulverizador',
        colors: [
          { color: 'amarelo', path: `${B}/atomizador_amarelo07.png` },
          { color: 'azul', path: `${B}/atomizador_azul08.png` },
          { color: 'laranja', path: `${B}/atomizador_laranja09.png` },
          { color: 'verde', path: `${B}/atomizador_verde10.png` },
          { color: 'vermelho', path: `${B}/atomizador_vermelho11.png` },
        ],
      },
    ],
  },
  {
    id: 'distribuidor',
    label: 'Distribuidores',
    subtypes: [
      {
        key: 'distribuidor_calcario', label: 'Distribuidor de Calcário',
        colors: [
          { color: 'amarelo', path: `${B}/distribuidor_calcario_amarelo40.png` },
          { color: 'azul', path: `${B}/distribuidor_calcario_azul41.png` },
          { color: 'laranja', path: `${B}/distribuidor_calcario_laranja42.png` },
          { color: 'verde', path: `${B}/distribuidor_calcario_verde43.png` },
          { color: 'vermelho', path: `${B}/distribuidor_calcario_vermelho44.png` },
        ],
      },
      {
        key: 'distribuidor_adubo', label: 'Distribuidor de Adubo',
        colors: [
          { color: 'amarelo', path: `${B}/semeadora_lanco_amarelo97.png` },
          { color: 'azul', path: `${B}/semeadora_lanco_azul98.png` },
          { color: 'laranja', path: `${B}/semeadora_lanco_laranja99.png` },
          { color: 'verde', path: `${B}/semeadora_lanco_verde100.png` },
          { color: 'vermelho', path: `${B}/semeadora_lanco_vermelho101.png` },
        ],
      },
      {
        key: 'adubadeira_linha', label: 'Adubadeira em Linha',
        colors: [
          { color: 'amarelo', path: `${B}/adubadeira_linha_amarelo01.png` },
          { color: 'laranja', path: `${B}/adubadeira_linha_laranja02.png` },
          { color: 'verde', path: `${B}/adubadeira_linha_verde03.png` },
          { color: 'vermelho', path: `${B}/adubadeira_linha_vermelho04.png` },
        ],
      },
      {
        key: 'caminhao_calcario', label: 'Caminhão Calcário',
        colors: [
          { color: 'laranja', path: `${B}/caminhao_calcario_laranja03.png` },
        ],
      },
    ],
  },
  {
    id: 'implemento',
    label: 'Implementos',
    subtypes: [
      {
        key: 'arado_discos', label: 'Arado de Discos',
        colors: [{ color: 'vermelho', path: `${B}/arado_discos_vermelho06.png` }],
      },
      {
        key: 'arado_aivecas', label: 'Arado de Aivecas',
        colors: [{ color: 'vermelho', path: `${B}/arado_aivecas_vermelho05.png` }],
      },
      {
        key: 'grade_aradora', label: 'Grade Aradora',
        colors: [{ color: 'vermelho', path: `${B}/grade_aradora_vermelho48.png` }],
      },
      {
        key: 'grade_niveladora', label: 'Grade Niveladora',
        colors: [{ color: 'vermelho', path: `${B}/grade_niveladora_vermelho49.png` }],
      },
      {
        key: 'subsolador', label: 'Subsolador',
        colors: [{ color: 'vermelho', path: `${B}/subsolador_vermelho103.png` }],
      },
      {
        key: 'escarificador', label: 'Escarificador',
        colors: [{ color: 'vermelho', path: `${B}/escarificador_vermelho46.png` }],
      },
      {
        key: 'rolo_faca', label: 'Rolo-Faca',
        colors: [{ color: 'vermelho', path: `${B}/rolo_faca_vermelho96.png` }],
      },
      {
        key: 'rocadora', label: 'Roçadora',
        colors: [{ color: 'vermelho', path: `${B}/rocadora_vermelho95.png` }],
      },
      {
        key: 'cultivador', label: 'Cultivador',
        colors: [{ color: 'vermelho', path: `${B}/cultivador_vermelho36.png` }],
      },
    ],
  },
  {
    id: 'irrigacao',
    label: 'Irrigação',
    subtypes: [
      {
        key: 'pivo_central', label: 'Pivô Central',
        colors: [{ color: 'verde', path: `${B}/pivo_central_verde55.png` }],
      },
    ],
  },
  {
    id: 'transporte',
    label: 'Transporte',
    subtypes: [
      {
        key: 'caminhao_graneleiro', label: 'Caminhão Graneleiro',
        colors: [
          { color: 'amarelo', path: `${B}/caminhao_graneleiro_amarelo01.png` },
          { color: 'azul', path: `${B}/caminhao_graneleiro_azul02.png` },
          { color: 'preto', path: `${B}/caminhao_graneleiro_preto04.png` },
          { color: 'verde', path: `${B}/caminhao_graneleiro_verde06.png` },
          { color: 'vermelho', path: `${B}/caminhao_graneleiro_vermelho07.png` },
        ],
      },
      {
        key: 'caminhao_carga', label: 'Caminhão de Carga',
        colors: [{ color: 'vermelho', path: `${B}/caminhao_carga_vermelho12.png` }],
      },
      {
        key: 'carreta_agricola', label: 'Carreta Agrícola',
        colors: [{ color: 'vermelho', path: `${B}/carreta_agricola_vermelho08.png` }],
      },
      {
        key: 'transbordo', label: 'Transbordo',
        colors: [{ color: 'vermelho', path: `${B}/transbordo_vermelho106.png` }],
      },
      {
        key: 'tanque_combustivel', label: 'Tanque de Combustível',
        colors: [{ color: 'vermelho', path: `${B}/tanque_combustivel_vermelho105.png` }],
      },
      {
        key: 'tanque_agua', label: 'Tanque de Água',
        colors: [{ color: 'vermelho', path: `${B}/tanque_agua_vermelho104.png` }],
      },
    ],
  },
  {
    id: 'outros',
    label: 'Outros',
    subtypes: [
      {
        key: 'drone_monitoramento', label: 'Drone de Monitoramento',
        colors: [{ color: 'verde', path: `${B}/drone_monitoramento_verde45.png` }],
      },
    ],
  },
]
